import { useGlobalSearchParams, usePathname } from "expo-router";

/**
 * This hook hook saves the current pathname and the query string
 * and returns as a combined string
 * @returns the redirect url with the query string
 */
export default function useRedirectUrl() {
  const pathname = usePathname();
  const params = useGlobalSearchParams<{ [key: string]: string }>();
  const urlSearchParams = new URLSearchParams(params);
  const queryString =
    urlSearchParams.size > 0 ? "?" + String(urlSearchParams) : "";
  return pathname + queryString;
}
